import logHandledError from '../../../../../../helpers/log-handled-error';
async function identifySegmentTracker(segmentTracker, params) {
    if (!segmentTracker) {
        return;
    }
    if (!params.userId) {
        logHandledError('TrackInteractionProvider: userId is required for identifying an user', params);
        return;
    }
    const { success, message } = await segmentTracker.identify(params);
    if (success !== true) {
        logHandledError('SegmentTracker: Error identifying user', { message });
    }
}
export default identifySegmentTracker;
